module.exports = __webpack_public_path__ + "img/apk-day.c14fc0b8.png";